module.exports = __webpack_public_path__ + "img/三资台账.85e979c4.png";